import ProfessionalCard from '@/components/ProfessionalCard';
import type { ApiCompanyProfessionals } from '@/types/api';

interface BookingProfessionalStepProps {
  onSelectProfessional: (id: string) => void;
  professionals: ApiCompanyProfessionals[];
  selectedProfessionalId: string;
}

const BookingProfessionalStep = ({
  onSelectProfessional,
  professionals,
  selectedProfessionalId,
}: BookingProfessionalStepProps) => {
  return (
    <div className="animate-fade-in-up">
      <p className="text-muted-foreground mb-5 text-sm">Escolha um profissional para seus serviços</p>
      {professionals.length === 0 && (
        <p className="bg-muted text-muted-foreground rounded-xl p-4 text-sm">
          Nenhum profissional disponível para os serviços selecionados. Volte e escolha outros serviços.
        </p>
      )}
      <div className="space-y-3">
        {professionals.map((professional) => (
          <ProfessionalCard
            key={professional.id}
            professional={professional}
            selected={selectedProfessionalId === professional.id}
            onSelect={onSelectProfessional}
          />
        ))}
      </div>
    </div>
  );
};

export default BookingProfessionalStep;
